<lin-progress-bar [isShown]="!dataSource || (dataSource.isLoading$ | async)"></lin-progress-bar>
<form [formGroup]="form">
  <lin-table [dataSource]="dataSource" matSort>
    <!-- Vehicle Reg No -->
    @if (!driverId) {
    <lin-table-column name="fullName" [label]="'FIELDS.DRIVER_NAME' | translate">
      <ng-container *ng="let document">
        @if (hasPermission(PermissionsSource['DRIVERS.DRIVERS_LIST'])) {
        <lin-cell-link routerLink="../{{ document.driver.id }}"> {{ document.driver.fullName }} </lin-cell-link>
        } @if (!hasPermission(PermissionsSource['DRIVERS.DRIVERS_LIST'])) {
        <lin-cell-text>{{ document.driver.fullName }}</lin-cell-text>
        }
      </ng-container>
    </lin-table-column>

    <lin-table-header-control name="fullName-search">
      <input matInput formControlName="fullName" autocomplete="off" />
    </lin-table-header-control>
    }

    <!--Title -->
    <lin-table-column name="title" sticky>
      <ng-container *ng="let document">
        <lin-cell-link [routerLink]="driverId ? document.id : ['..', document.driver.id, 'documents', document.id]">
          {{ document.title }}
        </lin-cell-link>
      </ng-container>
    </lin-table-column>

    <lin-table-header-control name="title-search" sticky>
      <input matInput formControlName="title" autocomplete="off" />
    </lin-table-header-control>

    <!--Status -->
    <lin-table-column name="status">
      <lin-cell-text *ng="let document">{{ DocumentStatusLabel[document.status] | translate }}</lin-cell-text>
    </lin-table-column>

    <ng-container matColumnDef="status-search">
      <mat-header-cell *matHeaderCellDef>
        <mat-form-field class="max-90">
          <mat-select formControlName="status">
            <mat-option value=""></mat-option>
            @for (status of DocumentStatusLabel | keys; track status) {
            <mat-option [value]="status">{{ DocumentStatusLabel[status] | translate }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-header-cell>
    </ng-container>

    <!--Remaining days -->
    <lin-table-column name="remainingDays">
      <lin-remaining-progress-bar
        *ng="let document"
        [title]="displayRemainingDays(document.remainingDays)"
        [currentValue]="document.remainingDays"
        baseValue="{{ document | dayjsDaysBetweenDates: document.issueDate:document.expDate }}"
      ></lin-remaining-progress-bar>
    </lin-table-column>

    <lin-table-header-control name="remainingDays-search">
      <input type="number" matInput formControlName="remainingDays" autocomplete="off" />
    </lin-table-header-control>

    <!-- Issue date -->
    <lin-table-column name="issueDate">
      <lin-cell-text *ng="let document">{{ document.issueDate | dayjsDate }}</lin-cell-text>
    </lin-table-column>

    <ng-container matColumnDef="issueDate-search">
      <mat-header-cell *matHeaderCellDef>
        <lin-datepicker-field formControlName="issueDate" [isRange]="true" [isWithTimePicker]="true"></lin-datepicker-field>
      </mat-header-cell>
    </ng-container>

    <!-- Expiration date -->
    <lin-table-column name="expDate">
      <lin-cell-text *ng="let document">{{ document.expDate | dayjsDate }}</lin-cell-text>
    </lin-table-column>

    <ng-container matColumnDef="expDate-search">
      <mat-header-cell *matHeaderCellDef>
        <lin-datepicker-field
          formControlName="expDate"
          [isNoMaxDate]="true"
          [isRange]="true"
          [isWithTimePicker]="true"
        ></lin-datepicker-field>
      </mat-header-cell>
    </ng-container>

    <!-- Delete -->
    <ng-container matColumnDef="delete">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon">{{ 'BUTTONS.DELETE' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let document" class="g-table-column-icon">
        @if (isDeletePossible(document)) { @if (isProcessing[document.id]) {
        <mat-spinner strokeWidth="2" diameter="20" color="accent"></mat-spinner>
        } @if (!isProcessing[document.id]) {
        <button mat-icon-button (click)="deleteDocument(document)" [matTooltip]="'BUTTONS.DELETE' | translate">
          <mat-icon svgIcon="delete_outline"></mat-icon>
        </button>
        } }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="delete-search">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon"></mat-header-cell>
    </ng-container>

    <!-- Edit Column -->
    <ng-container matColumnDef="edit">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon">{{ 'BUTTONS.EDIT' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let document" class="g-table-column-icon">
        <button
          mat-icon-button
          [routerLink]="driverId ? document.id : ['..', document.driver.id, 'documents', document.id]"
          [matTooltip]="'BUTTONS.EDIT' | translate"
        >
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="edit-search">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon"></mat-header-cell>
    </ng-container>

    <!-- Archive Column -->
    <ng-container matColumnDef="archive">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon">{{ 'BUTTONS.ARCHIVE' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let document" class="g-table-column-icon">
        @if (isProcessing[document.id]) {
        <mat-spinner strokeWidth="2" diameter="20" color="accent"></mat-spinner>
        } @if (isArchivePossible(document)) { @if (!isProcessing[document.id]) {
        <button mat-icon-button (click)="archiveDocument(document)" [matTooltip]="'BUTTONS.ARCHIVE' | translate">
          <mat-icon>archive</mat-icon>
        </button>
        } } @else { @if (!isProcessing[document.id]) {
        <button mat-icon-button (click)="restoreDocument(document.id)" [matTooltip]="'BUTTONS.RESTORE' | translate">
          <mat-icon>unarchive</mat-icon>
        </button>
        } }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="archive-search">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon"></mat-header-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="settings.columnsDisplayed; sticky: true"></mat-header-row>
    <mat-header-row *matHeaderRowDef="settings.columnsSearchDisplayed; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: settings.columnsDisplayed"></mat-row>
  </lin-table>

  <lin-table-toolbar>
    <lin-table-toolbar-button-row>
      @if (hasPermission(PermissionsSource['DRIVERS.DOCUMENTS_LIST.ADD'])) {
      <button type="button" mat-raised-button color="accent" routerLink="../documents/new">
        {{ 'CLIENT.VEHICLES.DOCUMENTS.ADD_NEW' | translate }}
      </button>
      }
      <mat-checkbox formControlName="showArchived">{{ 'CLIENT.VEHICLES.DOCUMENTS.SHOW_ARCHIVED' | translate }}</mat-checkbox>
    </lin-table-toolbar-button-row>
    <mat-paginator linPaginatorDefault></mat-paginator>
  </lin-table-toolbar>
</form>

<lin-table-settings #settings [columns]="columns" [columnsMandatory]="columnsMandatory" [disableExportPDF]="true"></lin-table-settings>
